const accountsUrl = "./accounts";
const caseUrl = "./case";

export const submitMyContract = accountsUrl + "/account/cancellation";
export const getActiveCancellationCases = caseUrl + "/activecancellationcases";
